import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#2C1E0F] text-white/80" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div>
            <Link to="/" className="inline-block mb-6">
              <span className="text-2xl font-black tracking-tighter text-white">
                Nature<span className="text-[#E0A106]">Wayz</span>
              </span>
            </Link>
            <p className="text-white/60 mb-6 leading-relaxed">
              Pure Nature, Delivered to You. We bring the finest organic products from nature to your doorstep.
            </p>
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#E0A106] transition-colors"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#E0A106] transition-colors"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#E0A106] transition-colors"
                data-testid="social-twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="hover:text-[#E0A106] transition-colors" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/shop" className="hover:text-[#E0A106] transition-colors" data-testid="footer-link-shop">
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-[#E0A106] transition-colors" data-testid="footer-link-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#E0A106] transition-colors" data-testid="footer-link-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Categories</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/shop?category=honey" className="hover:text-[#E0A106] transition-colors" data-testid="footer-category-honey">
                  Honey
                </Link>
              </li>
              <li>
                <Link to="/shop?category=dates" className="hover:text-[#E0A106] transition-colors" data-testid="footer-category-dates">
                  Dates
                </Link>
              </li>
              <li>
                <Link to="/shop?category=seeds" className="hover:text-[#E0A106] transition-colors" data-testid="footer-category-seeds">
                  Seeds
                </Link>
              </li>
              <li>
                <Link to="/shop?category=dry-fruits" className="hover:text-[#E0A106] transition-colors" data-testid="footer-category-dry-fruits">
                  Dry Fruits
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#E0A106] flex-shrink-0 mt-0.5" />
                <span data-testid="footer-address">17/5 A-1 Sadar Cantt Lahore, Pakistan</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#E0A106] flex-shrink-0" />
                <a href="tel:+923230480609" className="hover:text-[#E0A106] transition-colors" data-testid="footer-phone">
                  +92 323 048 0609
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#E0A106] flex-shrink-0" />
                <a href="mailto:support@naturewayz.com" className="hover:text-[#E0A106] transition-colors" data-testid="footer-email">
                  support@naturewayz.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm" data-testid="footer-copyright">
            © {new Date().getFullYear()} NatureWayz. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm">
            <Link to="/privacy" className="text-white/50 hover:text-[#E0A106] transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-white/50 hover:text-[#E0A106] transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
